import React, { useEffect, useRef } from 'react';

export const AudioVisualizer = ({ analyser, bufferState }) => {
  const canvasRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    canvas.width = 400;
    canvas.height = 400;

    const drawLoadingCircle = () => {
      const size = canvas.width;
      const centerX = size / 2;
      const centerY = size / 2;
      const innerRadius = 60;
      const maxRadius = size / 2 - 20;
      const time = Date.now() * 0.001;

      ctx.clearRect(0, 0, size, size);

      // Draw ripple effect
      for (let i = 0; i < 3; i++) {
        const rippleRadius = innerRadius + 
          ((maxRadius - innerRadius) * 0.7) * 
          (0.3 + 0.7 * Math.sin(time * 2 - i * 1.5));

        const gradient = ctx.createRadialGradient(
          centerX, centerY, innerRadius,
          centerX, centerY, rippleRadius
        );

        gradient.addColorStop(0, `rgba(100, 180, 255, ${0.4 - i * 0.1})`);
        gradient.addColorStop(1, 'rgba(100, 180, 255, 0)');

        ctx.beginPath();
        ctx.arc(centerX, centerY, rippleRadius, 0, Math.PI * 2);
        ctx.fillStyle = gradient;
        ctx.fill();
      }

      const innerGradient = ctx.createRadialGradient(
        centerX, centerY, 0,
        centerX, centerY, innerRadius
      );
      innerGradient.addColorStop(0, 'rgba(100, 180, 255, 0.8)');
      innerGradient.addColorStop(1, 'rgba(100, 180, 255, 0.5)');

      ctx.beginPath();
      ctx.arc(centerX, centerY, innerRadius, 0, Math.PI * 2);
      ctx.fillStyle = innerGradient;
      ctx.fill();
    };

    const drawVisualization = () => {
      if (!analyser) return;

      const size = canvas.width;
      const centerX = size / 2;
      const centerY = size / 2;
      const innerRadius = 60;
      const maxRadius = size / 2 - 20;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
      
      analyser.getByteFrequencyData(dataArray);
      const intensity = dataArray.reduce((acc, val) => acc + val, 0) / (bufferLength * 255);

      ctx.clearRect(0, 0, size, size);

      const glowRadius = innerRadius + (maxRadius - innerRadius) * intensity;
      const gradient = ctx.createRadialGradient(
        centerX, centerY, innerRadius,
        centerX, centerY, glowRadius
      );

      gradient.addColorStop(0, `rgba(208, 78, 192, 0.8)`);
      gradient.addColorStop(0.2, `rgba(208, 78, 192, 0.5)`);
      gradient.addColorStop(0.5, `rgba(208, 78, 192, 0.3)`);
      gradient.addColorStop(0.8, `rgba(208, 78, 192, 0.1)`);
      gradient.addColorStop(1, `rgba(208, 78, 192, 0)`);

      ctx.beginPath();
      ctx.arc(centerX, centerY, glowRadius, 0, Math.PI * 2);
      ctx.fillStyle = gradient;
      ctx.fill();

      ctx.beginPath();
      ctx.arc(centerX, centerY, innerRadius, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(208, 78, 192, 1)`;
      ctx.fill();
    };

    const animate = () => {
      if (bufferState === 'ready' && analyser) {
        drawVisualization();
      } else {
        drawLoadingCircle();
      }
      animationFrameRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [analyser, bufferState]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        backgroundColor: 'transparent',
        width: '300px',
        height: '300px',
      }}
    />
  );
};